import {
  ONBOARDING_TABS,
  PATIENT_SECTIONS,
  type OnboardingTabId,
  type PatientSectionId,
} from "@/frontend/types/dashboard/nav";

/**
 * Reads the active section from the pathname. Matches any segment, not the last
 * one, since Onboarding carries its open tab in the path. `connections` keeps
 * Onboarding lit. Unknown paths fall back to `summary`.
 */
export function activeSectionFrom(pathname: string): PatientSectionId {
  const segments = pathname.split("/").filter(Boolean);
  if (segments.includes("connections")) return "onboarding";
  const match = PATIENT_SECTIONS.find((section) => segments.includes(section.id));
  return match?.id ?? "summary";
}

/** True when a path segment names one of the tabs. */
export function isOnboardingTabId(value: string): value is OnboardingTabId {
  return ONBOARDING_TABS.some((tab) => tab.id === value);
}
